export default __webpack_public_path__ + "static/media/pw-add-form-3.ca4f605e.jpg";